/**
 * Bundle Benefits — Dynamic variant-specific benefits for product pages.
 *
 * Reads a Liquid-generated JSON data block (#variant-benefits-data) that maps
 * variant IDs → { name, benefits[] }.  On variant change it swaps the visible
 * benefit bullets and the bundle subtitle without any network request.
 *
 * Dependencies : none (vanilla JS, no jQuery)
 * Loaded on    : product pages only (guarded by Liquid condition)
 */
(function () {
  'use strict';

  /* ── Data ────────────────────────────────────────────────────────── */

  var dataEl = document.getElementById('variant-benefits-data');
  if (!dataEl) return;

  var benefitsMap;
  try {
    benefitsMap = JSON.parse(dataEl.textContent);
  } catch (_e) {
    return;
  }

  /* ── DOM helpers ─────────────────────────────────────────────────── */

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(text));
    return div.innerHTML;
  }

  function getVariantIdFromUrl() {
    var params = new URLSearchParams(window.location.search);
    return params.get('variant');
  }

  function getActiveVariantId() {
    var urlVariant = getVariantIdFromUrl();
    if (urlVariant) return urlVariant;

    var checked = document.querySelector(
      'variant-radios input[type="radio"]:checked, ' +
        'variant-sticky-radios input[type="radio"]:checked'
    );
    return checked ? checked.getAttribute('data-variant-id') : null;
  }

  /* ── Render ──────────────────────────────────────────────────────── */

  function renderBenefits(variantId) {
    var data = benefitsMap[String(variantId)];
    if (!data) return;

    var benefits = data.benefits;
    if (!benefits || !benefits.length) return;

    /* Update benefit bullets */
    var containers = document.querySelectorAll('.highlightes__pointss');
    containers.forEach(function (container) {
      var html = '<div class="metafield-rich_text_field"><ul>';
      benefits.forEach(function (benefit) {
        html += '<li>' + escapeHtml(benefit) + '</li>';
      });
      html += '</ul></div>';
      container.innerHTML = html;
    });

    /* Update subtitle */
    var subtitleEl = document.getElementById('bundle-subtitle');
    if (subtitleEl) {
      if (data.name) {
        subtitleEl.innerHTML = '<strong>' + escapeHtml(data.name) + '</strong>';
        subtitleEl.style.display = 'block';
      } else {
        subtitleEl.style.display = 'none';
      }
    }
  }

  /* ── Events ──────────────────────────────────────────────────────── */

  function bindEvents() {
    /* Variant radio change (works for both desktop & sticky mobile radios) */
    document.addEventListener('change', function (e) {
      var radio = e.target;
      if (radio.type !== 'radio') return;

      var parent = radio.closest('variant-radios, variant-sticky-radios');
      if (!parent) return;

      var variantId = radio.getAttribute('data-variant-id');
      if (variantId) renderBenefits(variantId);
    });

    /* Browser back/forward (Ella updates URL via history.replaceState) */
    window.addEventListener('popstate', function () {
      var variantId = getVariantIdFromUrl();
      if (variantId) renderBenefits(variantId);
    });
  }

  /* ── Init ─────────────────────────────────────────────────────────── */

  function init() {
    bindEvents();

    var initialVariant = getActiveVariantId();
    if (initialVariant) renderBenefits(initialVariant);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
